.tableWrapper {
  border: 1px solid var(--pgm-sys-color-outline-variant);
  border-radius: 8px;
  overflow-x: auto;
}

.table {
  border-collapse: collapse;
  margin: 0;
  min-width: 900px;
  width: 100%;

  th,
  td {
    box-sizing: border-box;
    height: 40px;
    padding: var(--pgm-sys-spacing-1) var(--pgm-sys-spacing-4);
    text-align: left;
    vertical-align: middle;
  }

  thead th {
    background-color: var(--pgm-sys-color-surface-container-low);
    color: var(--pgm-sys-color-on-surface-variant);
    font-weight: inherit;
  }

  tbody th,
  tbody td {
    color: var(--pgm-sys-color-on-surface);
    font-weight: inherit;
  }

  tr {
    border-bottom: 1px solid var(--pgm-sys-color-outline-variant);
  }

  tbody tr:last-child {
    border-bottom: 0;
  }

  a {
    color: var(--pgm-sys-color-secondary);
    text-decoration: underline;
  }

  a:focus-visible {
    outline: 3px solid var(--pgm-sys-color-secondary);
    outline-offset: 2px;
  }
}

.tableWrapper a:hover,
.tableWrapper a:focus {
  color: var(--pgm-sys-color-secondary);
  text-decoration: underline;
}

.acronym {
  width: 148px;
}

.extension {
  width: 148px;
}

.personInCharge {
  width: 280px;
}

.email {
  width: 364px;
}

.fullName {
  width: auto;
}
